import React from 'react';
import styled from 'styled-components';
import headerIcon from '../assets/images/loading-icon.jpg';

const Header = () => {
  return (
    <HeaderContainer>
      <HeaderImage src={headerIcon} alt="Stoic Wisdom Icon" />
      <Logo>Stoic Wisdom</Logo>
      <Tagline>Ancient wisdom for modern resilience</Tagline>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  padding: 1.5rem 1rem 1rem;
  text-align: center;
  background: linear-gradient(to bottom, #000000, #111111);
  border-bottom: 1px solid #d4af37;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 150px;
    height: 1px;
    background: linear-gradient(to right, transparent, #d4af37, transparent);
  }
`;

const HeaderImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 1rem;
  border: 3px solid #d4af37;
  box-shadow: 0 0 20px rgba(212, 175, 55, 0.3);

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
  }
`;

const Logo = styled.h1`
  font-family: var(--font-primary);
  font-size: 2.5rem;
  /* Golden color for the headline */
  color: #d4af37;
  background: linear-gradient(to right, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  margin-bottom: 0.3rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(to right, transparent, #d4af37, transparent);
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Tagline = styled.p`
  font-family: var(--font-secondary);
  font-size: 1rem;
  color: #a8a8a8;
  font-style: italic;
  margin-top: 0.5rem;
  letter-spacing: 1px;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export default Header;
